<template>
  <v-text-field
    v-model="password"
    :rules="rules"
    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
    :type="showPassword ? 'text' : 'password'"
    :label="label"
    class="fs-exclude input-group--focused"
    outlined
    required
    :autocomplete="autocomplete"
    @click:append="showPassword = !showPassword"
  />
</template>
<script>
export default {
  props: {
    label: { type: String, default: null },
    value: { type: String, default: null },
    rules: { type: Array, default: () => [] },
    autocomplete: { type: String, default: 'current-password' }
  },
  data() {
    return {
      showPassword: false
    }
  },
  computed: {
    password: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
